module.exports = __webpack_public_path__ + "static/img/prize1.224777a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_activitycenter/prize1.png
// module id = 5edg
// module chunks = 1